window.$ = window.jQuery = require('jquery');
require('/../../zimpledigital-widespan-template/sources/js/vendor/modernizr-custom');
require('/../../zimpledigital-widespan-template/sources/js/vendor/form-builder');
require('jquery-nice-select');
require('./../../node_modules/@fancyapps/ui/dist/fancybox.esm.js');

import gaEvents from '/../../zimpledigital-widespan-template/sources/js/vendor/ga-events';
import forms from '/../../zimpledigital-widespan-template/sources/js/_forms';
import sliders from '/../../zimpledigital-widespan-template/sources/js/_sliders';
import pagination from '/../../zimpledigital-widespan-template/sources/js/_pagination';
import gMap from '/../../zimpledigital-widespan-template/sources/js/_map';
import fancyboxCustom from '/../../zimpledigital-widespan-template/sources/js/_fancybox';
import accordions from '/../../zimpledigital-widespan-template/sources/js/_accordions';
import tabs from '/../../zimpledigital-widespan-template/sources/js/_tabs';
import popout from '/../../zimpledigital-widespan-template/sources/js/_popout';
import modules from '/../../zimpledigital-widespan-template/sources/js/_modules';
import menu from '/../../zimpledigital-widespan-template/sources/js/_menu';
import checkout from '/../../zimpledigital-widespan-template/sources/js/_checkout';
import defaultApp from '/../../zimpledigital-widespan-template/sources/js/_default-app';
import extras from './_extras';
 
$(function() { // Shorthand for $( document ).ready()
    "use strict";
    // Your js script is below this line
    // --------------------------------------------------------------------- //

    window.GA = new gaEvents();
    GA.init();

    window.Forms = new forms();
    Forms.init();

    window.Sliders = new sliders();
    Sliders.init();

    window.Pagination = new pagination();
    Pagination.init();

    window.GMap = new gMap();
    GMap.init();

    window.FancyboxCustom = new fancyboxCustom();
    FancyboxCustom.init();

    window.Accordions = new accordions();
    Accordions.init();

    window.Tabs = new tabs();
    Tabs.init();

    window.Popout = new popout();
    Popout.init();

    window.Modules = new modules();
    Modules.init();

    window.Menu = new menu();
    Menu.init();

    window.DefaultApp = new defaultApp();
    DefaultApp.init();

    window.Extras = new extras();
    Extras.init();

    window.Checkout = new checkout();
    Checkout.init();

    window.lazyLoadOptions = {
        // Your custom settings go here
    }
});